import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { GkComponentsModule, GkMapModule } from '@gk/gk-modules';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/shared.module';
import { createTranslateLoader } from '../address-number-request-portal/address-number-request-portal.module';
import { MCGRFinancialSectorApplicationFormArrayComponent } from './financial-sector-application-form-array/financial-sector-application-form-array.component';
import { MonumentConservationGrantRequestRoutingModule } from './monument-conservation-grant-request-routing.module';
import { MonumentConservationGrantRequestComponent } from './monument-conservation-grant-request.component';
import { MCGRNewRequestComponent } from './new-request/new-request.component';
import { MCGROtherConservationActivitiesFormArrayComponent } from './other-conservation-activities-form-array/other-conservation-activities-form-array.component';
import { MCGRPermitSectionComponent } from './permit-section/permit-section.component';
import { MCGRNewRequestFormService } from './services/new-request-form/new-request-form.service';
import { MCGRWorksEstimatedCostsComponent } from './works-estimated-costs/works-estimated-costs.component';

@NgModule({
  declarations: [
    MonumentConservationGrantRequestComponent,
    MCGRNewRequestComponent,
  ],
  imports: [
    SharedModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    GkMapModule,
    GkComponentsModule,
    MonumentConservationGrantRequestRoutingModule,
    MatCheckboxModule,
    MCGRPermitSectionComponent,
    MCGRFinancialSectorApplicationFormArrayComponent,
    MCGRWorksEstimatedCostsComponent,
    MCGROtherConservationActivitiesFormArrayComponent,
  ],
  providers: [MCGRNewRequestFormService],
})
export class MonumentConservationGrantRequestModule {}
